import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { recipeDetailCategory } from 'src/app/core/model/api-response/recipe-response-model';
import {
  FoodModel,
  FoodUnitIdModel,
  FoodUnitRatioModel,
} from 'src/app/core/model/object/diet-food-model';
import { RecipeDetailModel } from 'src/app/core/model/object/recipe-model';
import { CookingStoryRecipePageDataService } from 'src/app/data/repository/cooking-story/cooking-story-recipe-page-data.service';
import { CookingStoryService } from 'src/app/data/repository/cooking-story/cooking-story.service';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { RecipeDetailBottomsheetComponent } from '../../recipe/recipe-detail-bottomsheet/recipe-detail-bottomsheet.component';
import { CookingStoryBottomSheetComponent } from '../cooking-story-bottom-sheet/cooking-story-bottom-sheet.component';

@Component({
  selector: 'app-cooking-story-recipe-page',
  templateUrl: './cooking-story-recipe-page.component.html',
  styleUrls: ['./cooking-story-recipe-page.component.scss'],
})
export class CookingStoryRecipePageComponent implements OnInit, OnDestroy {
  recipeId: string;
  recipe: RecipeDetailModel;
  categorie: recipeDetailCategory;
  isReady: boolean = false;
  activeTab = ' مواد ‌لازم ';
  activeTabNumber: number = 0;
  unitTitle = '';
  ratio: FoodUnitRatioModel;
  foodFactsNames = [];
  foodFactsUnits = [];
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  foodAmount = 100;
  shadowNav: boolean = false;
  showtutorial: boolean = false;
  unlike: boolean;
  liked: boolean = false;
  alfa: number = 1;
  showVideo: boolean = false;
  bottomSheetShow: boolean = false;
  url: string;
  firstload: boolean = false;
  fridge: number;
  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;
  subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recipeService: RecipeService,
    private snackBarService: SnackBarService,
    private planService: PlanService,
    private cookingstory: CookingStoryService,
    public bottomsheetShared: BottomsheetShared,
    private matBottomSheet: MatBottomSheet,
    private RecipePageDataService: CookingStoryRecipePageDataService
  ) {
    document.body.addEventListener('scroll', this.scrolling);
    this.ratio = new FoodUnitRatioModel(
      1,
      new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
    );
    this.unitTitle = this.foodAmount.toString() + ' ' + this.ratio.unitId.name;
    this.recipeId = this.route.snapshot.paramMap.get('recipeId');
    this.url = this.router.url;
    this.getRecipeDetail();
    const sub = this.bottomsheetShared.closeBottomsheetObs$.subscribe(() => {
      this.bottomSheetShow = false;
    });
    this.subscriptions.push(sub);
  }

  goBack() {
    this.planService.goBack();
  }

  goToTutorial() {
    this.recipeService.goToRecipeTutorial(this.recipeId);
  }

  showvideo() {
    this.showVideo = true;
  }
  showBottomSheet() {
    this.bottomSheetShow = true;
  }

  closevideo() {
    this.showVideo = false;
  }

  ngOnInit(): void {
    this.RecipePageDataService.clearList();
  }

  async getRecipeDetail() {
    this.recipeService.getRecipeDetail(this.recipeId, true).then((res) => {
      if (res.isSuccess()) {
        this.recipe = res.getData().getCookingStoryRecipe().recipe;
        this.categorie = res.getData().getCookingStoryRecipe().category;
        this.cookingstory.saveRecipe(res.getData().getCookingStoryRecipe());
        this.isReady = true;
        this.liked = this.recipe.bookmark;
        this.prepareFood();
        this.claclFridge();
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }
  claclFridge() {
    let total = 0;

    this.recipe.ingredients.map((ingredient) => {
      if (ingredient.kitchenInventory) {
        total += 1;
      }
    });

    this.fridge = parseInt(
      this.percentage(total, this.recipe.ingredients.length)
    );
  }
  openCartBottomSheet() {
    const data = this.recipe?.ingredients.slice(0);
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          ingredients: data,
        },
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }

  changeFoodAmountOrRatio() {
    const bottomSheetRef = this.matBottomSheet.open(
      RecipeDetailBottomsheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          food: this.recipe.food,
          selectedRatio: this.ratio.unitId.name,
          amount: this.foodAmount,
          cookingBook: true,
        },
      }
    );
    const sub = bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {
      if (dataFromChild) {
        this.foodAmount = dataFromChild.amount;
        if (dataFromChild.selectedRatio !== 'گرم') {
          this.recipe.food.foodUnitRatioArray.forEach((ratio) => {
            if (ratio.unitId.name === dataFromChild.selectedRatio) {
              this.ratio = ratio;
            }
          });
          this.unitTitle =
            this.foodAmount.toString() +
            ' ' +
            this.ratio.unitId.name +
            ' (' +
            this.foodAmount * this.ratio.ratio +
            ' گرم)';
        } else {
          this.ratio = new FoodUnitRatioModel(
            1,
            new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
          );
          this.unitTitle =
            this.foodAmount.toString() + ' ' + this.ratio.unitId.name;
        }
        this.prepareFood();
        sub.unsubscribe();
      }
    });
    this.subscriptions.push(sub);
  }
  garr(length: number) {
    return new Array(length);
  }
  Bookmarking() {
    this.liked = !this.liked;
    if (!this.liked && !this.unlike) {
      this.unlike = true;
      --this.recipe.likes;
    } else {
      this.unlike = false;
      ++this.recipe.likes;
    }
    this.recipeService.bookmark(this.recipeId);
  }

  scrolling(data) {
    let scroolTop = this.scroolEl.nativeElement.scrollTop;
    this.alfa = 1 - scroolTop / 170;

    if (scroolTop >= 235) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }

    if (scroolTop >= 180) {
      this.showtutorial = true;
    } else {
      this.showtutorial = false;
    }
  }
  percentage(percent: number, total: number) {
    return ((percent / total) * 100).toFixed(2);
  }
  prepareFood() {
    this.foodFactsNames = [];
    this.foodFactsUnits = [];
    this.foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.recipe.food.foodFactModel = this.planService.makeFoodFactsModel(
      this.recipe.food.foodFact
    );
    this.foodFactsAmount = this.prepareFoodFactsAmounts(
      this.recipe.food,
      this.foodFactsAmount,
      this.ratio
    );
    this.foodFactsNames = this.prepareFoodFactsPersianNames(this.recipe.food);
    this.foodFactsUnits = this.prepareFoodFactsPersianUnits(this.recipe.food);
    if (!this.firstload) {
      this.firstload = true;
      setTimeout(() => {
        document.getElementById('firstTab').click();
      }, 1000);
    }
  }

  increaseServing() {
    this.recipe.serving++;
    this.recipe.ingredients.forEach((ingredient) => {
      ingredient.amount =
        (ingredient.amount / (this.recipe.serving - 1)) * this.recipe.serving;
    });
  }

  decreaseServing() {
    if (this.recipe.serving > 1) {
      this.recipe.serving--;
      this.recipe.ingredients.forEach((ingredient) => {
        ingredient.amount =
          (ingredient.amount / (this.recipe.serving + 1)) * this.recipe.serving;
      });
    }
  }

  addZeroes(num: string) {
    const dec = num.split('.')[1];
    const len = dec ? (dec.length < 2 ? dec.length : 2) : 0;
    return Number(num).toFixed(len);
  }

  prepareFoodFactsAmounts(
    foodModel: FoodModel,
    foodFactsAmount: number[],
    ratio: FoodUnitRatioModel
  ): number[] {
    foodFactsAmount[0] =
      foodModel.foodFactModel.calorie.amount !== -1 &&
      this.foodFactsAmount[0] !== -1
        ? ((foodModel.foodFactModel.calorie.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[0]
        : -1;
    foodFactsAmount[1] =
      foodModel.foodFactModel.protein.amount !== -1 &&
      this.foodFactsAmount[1] !== -1
        ? ((foodModel.foodFactModel.protein.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[1]
        : -1;
    foodFactsAmount[2] =
      foodModel.foodFactModel.carbohydrate.amount !== -1 &&
      this.foodFactsAmount[2] !== -1
        ? ((foodModel.foodFactModel.carbohydrate.amount * this.foodAmount) /
            100) *
            ratio.ratio +
          foodFactsAmount[2]
        : -1;
    foodFactsAmount[3] =
      foodModel.foodFactModel.fat.amount !== -1 &&
      this.foodFactsAmount[3] !== -1
        ? ((foodModel.foodFactModel.fat.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[3]
        : -1;
    foodFactsAmount[4] =
      foodModel.foodFactModel.sugar.amount !== -1 &&
      this.foodFactsAmount[4] !== -1
        ? ((foodModel.foodFactModel.sugar.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[4]
        : -1;
    foodFactsAmount[5] =
      foodModel.foodFactModel.fiber.amount !== -1 &&
      this.foodFactsAmount[5] !== -1
        ? ((foodModel.foodFactModel.fiber.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[5]
        : -1;
    foodFactsAmount[6] =
      foodModel.foodFactModel.sodium.amount !== -1 &&
      this.foodFactsAmount[6] !== -1
        ? ((foodModel.foodFactModel.sodium.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[6]
        : -1;
    foodFactsAmount[7] =
      foodModel.foodFactModel.potassium.amount !== -1 &&
      this.foodFactsAmount[7] !== -1
        ? ((foodModel.foodFactModel.potassium.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[7]
        : -1;
    foodFactsAmount[8] =
      foodModel.foodFactModel.calcium.amount !== -1 &&
      this.foodFactsAmount[8] !== -1
        ? ((foodModel.foodFactModel.potassium.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[8]
        : -1;
    foodFactsAmount[9] =
      foodModel.foodFactModel.magnesium.amount !== -1 &&
      this.foodFactsAmount[9] !== -1
        ? ((foodModel.foodFactModel.magnesium.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[9]
        : -1;
    foodFactsAmount[10] =
      foodModel.foodFactModel.phosphor.amount !== -1 &&
      this.foodFactsAmount[10] !== -1
        ? ((foodModel.foodFactModel.phosphor.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[10]
        : -1;
    foodFactsAmount[11] =
      foodModel.foodFactModel.iron.amount !== -1 &&
      this.foodFactsAmount[11] !== -1
        ? ((foodModel.foodFactModel.iron.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[11]
        : -1;
    foodFactsAmount[12] =
      foodModel.foodFactModel.saturatedFat.amount !== -1 &&
      this.foodFactsAmount[12] !== -1
        ? ((foodModel.foodFactModel.saturatedFat.amount * this.foodAmount) /
            100) *
            ratio.ratio +
          foodFactsAmount[12]
        : -1;
    foodFactsAmount[13] =
      foodModel.foodFactModel.monounsaturatedFat.amount !== -1 &&
      this.foodFactsAmount[13] !== -1
        ? ((foodModel.foodFactModel.monounsaturatedFat.amount *
            this.foodAmount) /
            100) *
            ratio.ratio +
          foodFactsAmount[13]
        : -1;
    foodFactsAmount[14] =
      foodModel.foodFactModel.polyunsaturatedFat.amount !== -1 &&
      this.foodFactsAmount[14] !== -1
        ? ((foodModel.foodFactModel.polyunsaturatedFat.amount *
            this.foodAmount) /
            100) *
            ratio.ratio +
          foodFactsAmount[14]
        : -1;
    foodFactsAmount[15] =
      foodModel.foodFactModel.transFat.amount !== -1 &&
      this.foodFactsAmount[15] !== -1
        ? ((foodModel.foodFactModel.transFat.amount * this.foodAmount) / 100) *
            ratio.ratio +
          foodFactsAmount[15]
        : -1;
    foodFactsAmount[16] =
      foodModel.foodFactModel.cholesterol.amount !== -1 &&
      this.foodFactsAmount[16] !== -1
        ? ((foodModel.foodFactModel.cholesterol.amount * this.foodAmount) /
            100) *
            ratio.ratio +
          foodFactsAmount[16]
        : -1;
    return foodFactsAmount;
  }

  prepareFoodFactsPersianNames(foodModel: FoodModel): string[] {
    return [
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianName(foodModel.foodFactModel.fat.name),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianName(
        foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  prepareFoodFactsPersianUnits(foodModel: FoodModel): string[] {
    return [
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianUnit(foodModel.foodFactModel.fat.name),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  changeTab(e: MouseEvent, index: number) {
    let active: HTMLDivElement = e.target as HTMLDivElement;
    var firstEl = active.getBoundingClientRect().width;

    let left = (e.target as HTMLDivElement).offsetLeft;
    let last = 0;
    if (index == 2) {
      last = 17;
    } else if (index == 1) {
      last = 5;
    }
    document.getElementById('hover').style.left =
      left -
      firstEl / 2 +
      (e.target as HTMLDivElement).clientWidth / 2 -
      last -
      4 +
      'px';
    document.getElementById('hover').style.right = 'unset';
    this.activeTab = (e.target as HTMLDivElement).innerHTML;
    this.activeTabNumber = index;
    document.getElementById('hover').style.width = firstEl + 24 + 'px';
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
